"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateCustomerNewOrder = void 0;
const gs = require("@ivanlog/gs");
const com = require("../../com/tmpls");
const modalCom = require("@ivanlog/gs-com-modal_dialogs");
const L = require("leaflet");
const StatePaged_1 = require("../abstracts/StatePaged");
const models_1 = require("../../api/customer/classes/models");
const gs_1 = require("@ivanlog/gs");
const StateCustomerOrders_1 = require("./StateCustomerOrders");
const StateProfiles_1 = require("../profiles/StateProfiles");
class StateCustomerNewOrder extends StatePaged_1.StatePaged {
    constructor() {
        super(com.PageCustomerNewOrder, "New order", true);
        this._forCustomer = false;
        this._selectMode = "";
        this.page.ctrls.btnSelectUser.onclick = () => this._trySelectUser();
        this.page.ctrls.btnCalc.onclick = () => this.tryCheck();
        this.page.ctrls.btnConfirm.onclick = () => this.tryConfirm();
        this._selectMode = "";
        this.page.ctrls.btnSelectFrom.onclick = () => {
            this.setStartPoint(new models_1.Coordinates(this._map.getCenter()), true);
            this._selectMode = "start";
        };
        this.page.ctrls.btnSelectTo.onclick = () => {
            this.setEndPoint(new models_1.Coordinates(this._map.getCenter()), true);
            this._selectMode = "end";
        };
    }
    start(args) {
        const _super = Object.create(null, {
            start: { get: () => super.start }
        });
        return __awaiter(this, void 0, void 0, function* () {
            this._forCustomer = false;
            if (args)
                if (args.forCustomer)
                    this._forCustomer = true;
            if (this._customer)
                this._forCustomer = true;
            yield this.fill();
            this.page.ctrls.btnConfirm.hide();
            return _super.start.call(this);
        });
    }
    fill() {
        return __awaiter(this, void 0, void 0, function* () {
            let ctrl = this.page.ctrls;
            ctrl.rbType.html = "";
            let vtypes = yield this.app.astra.getVehiclesTypes();
            for (const vt of vtypes) {
                const btn = gs.w(gs.html.tag("button", { class: `${gs_1.ItemButton.TagClassName}` }, gs.text.clearHtmlToText(this._formatVehicleTypeLabel(vt))));
                btn.setData(gs_1.ItemButton.TagDataValue, vt.id.toString());
                ctrl.rbType.append(btn);
            }
            if (!this._forCustomer) {
                this._setCustomer(this.app.auth.session.user);
                this.page.ctrls.btnSelectUser.hide();
            }
        });
    }
    afterStart() {
        const _super = Object.create(null, {
            afterStart: { get: () => super.afterStart }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.afterStart.call(this);
            this._initMap();
        });
    }
    _initMap() {
        this._map = L.map("map").setView([48.142723, 11.576843], 10);
        let startIcon = L.icon({
            iconUrl: "images/icons/map-pin_start.svg",
            iconSize: [30, 60],
            iconAnchor: [15, 45],
        });
        let endIcon = L.icon({
            iconUrl: "images/icons/map-pin_end.svg",
            iconSize: [30, 60],
            iconAnchor: [15, 45],
        });
        L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
            maxZoom: 19,
            attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
        }).addTo(this._map);
        this._mapStartMarker = L.marker(this._map.getCenter(), {
            icon: startIcon,
        }).addTo(this._map);
        this._mapEndMarker = L.marker(this._map.getCenter(), {
            icon: endIcon,
        }).addTo(this._map);
        this._map.on("click", (ev) => {
            if (this._selectMode == "start")
                this.setStartPoint(ev.latlng, true);
            else if (this._selectMode == "end")
                this.setEndPoint(ev.latlng, true);
        });
    }
    tryCheck() {
        return __awaiter(this, void 0, void 0, function* () {
            //TODO время прибытия
            //Водитель грузчик
            let ctrls = this.page.ctrls;
            let selectedItem = this.page.ctrls.rbType.getSelectedItem();
            if (!selectedItem) {
                new modalCom.DialogOk("Vehicles type not selected").show();
                return false;
            }
            let vtypeId = parseInt(selectedItem.value);
            if (this._forCustomer)
                if (!this._customer) {
                    new modalCom.DialogOk("Customer not selected").show();
                    return false;
                }
            const flags = ctrls.cbFlags.value;
            const isDriverLikePorter = flags.indexOf("porter") >= 0;
            let needSearchRoute = true;
            if (this._route)
                if (this._route.locations[0].addressFull == ctrls.iFromAddress.value &&
                    this._route.locations[this._route.locations.length - 1].addressFull ==
                        ctrls.iToAddress.value)
                    needSearchRoute = false;
            if (needSearchRoute) {
                let fromLocation = new models_1.Location();
                let toLocation = new models_1.Location();
                if (ctrls.iFromAddress.value)
                    fromLocation.addressFull = ctrls.iFromAddress.value;
                else if (this._pointStart)
                    fromLocation.coordinates = this._pointStart;
                else {
                    new modalCom.DialogOk("Start location not selected").show();
                    return false;
                }
                if (ctrls.iToAddress.value)
                    toLocation.addressFull = ctrls.iToAddress.value;
                else if (this._pointEnd)
                    toLocation.coordinates = this._pointEnd;
                else {
                    new modalCom.DialogOk("End location not selected").show();
                    return false;
                }
                let routeRequest = new models_1.CalculateRouteRequest({
                    fromLocation,
                    toLocation,
                });
                routeRequest.fromLocation = fromLocation;
                routeRequest.toLocation = toLocation;
                if (ctrls.iTime.value)
                    routeRequest.departureTime = new Date(ctrls.iTime.value);
                let route = yield this.lockgui(this.app.api.customer.geo.calculateRoute(routeRequest));
                this._route = route;
            }
            if (!this._route)
                return;
            const locationStart = this._route.locations[0];
            const locationEnd = this._route.locations[this._route.locations.length - 1];
            this.setStartPoint(locationStart.coordinates);
            this.setEndPoint(locationEnd.coordinates);
            this.page.ctrls.iFromAddress.value = locationStart.addressFull;
            this.page.ctrls.iToAddress.value = locationEnd.addressFull;
            ctrls.btnConfirm.hide();
            let request = new models_1.CreatePreOrderRequest();
            request.routeId = this._route.id;
            request.vehicleTypeId = vtypeId;
            request.portersCount = 0;
            if (isDriverLikePorter)
                request.portersCount++;
            request.paymentMethodId = "";
            request.paymentProvider = "1";
            let preOrder;
            if (!this._forCustomer)
                preOrder = yield this.lockgui(this.app.api.customer.orders.create(request));
            else
                preOrder = yield this.lockgui(this.app.api.admin.activeManager.createPreOrderForCustomer(this._customer.id, request));
            if (!preOrder)
                return;
            this._preOrder = preOrder;
            const vt = yield this.app.astra.getVehiclesType(preOrder.vehicleTypeId);
            const vehicleTypeLabel = gs.text.clearHtmlToText(this._formatVehicleTypeLabel(vt));
            let offerHtml = `<b>Offer</b><br>` +
                `Vehicles type: ${vehicleTypeLabel}<br>` +
                `From: ${preOrder.route.locations[0].addressFull}<br>` +
                `To: ${preOrder.route.locations[preOrder.route.locations.length - 1]
                    .addressFull}<br>` +
                `departureTime: ${preOrder.route.departureTime}<br>` +
                `Estimated distance: ${preOrder.route.estimatedLengthKm}km<br>` +
                `Estimated time: ${Math.round(preOrder.route.estimatedTimeTotalSec / 60)}mins<br>` +
                `Estimated price: ${preOrder.estimatedPrice}<br>`;
            if (preOrder.isDriverLikePorter)
                offerHtml += `The driver work like a porter.<br>`;
            ctrls.lOffer.html = offerHtml;
            ctrls.btnConfirm.show();
        });
    }
    tryConfirm() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this._preOrder)
                return;
            const req = new models_1.OrderRequest();
            req.orderId = this._preOrder.id;
            let order = yield this.lockgui(this.app.api.customer.orders.confirm(req));
            if (!order)
                return;
            yield new modalCom.DialogOk("Order confirmed").show();
            gs_1.StateGS.Run(StateCustomerOrders_1.StateCustomerOrders);
        });
    }
    _formatVehicleTypeLabel(vtype) {
        if (!vtype)
            return "Vehicle type";
        const parts = [];
        if (vtype.sizeClass)
            parts.push(vtype.sizeClass);
        if (vtype.size)
            parts.push(`w${vtype.size.width} : l${vtype.size.length} : h${vtype.size.height}`);
        const summary = parts.filter(Boolean).join(" | ");
        return summary || `#${vtype.id}`;
    }
    setStartPoint(latlng, withClearAddress = false) {
        if (!latlng)
            return;
        this._mapStartMarker.setLatLng(latlng);
        this._pointStart = latlng;
        this.page.ctrls.iFromAddress.el.placeholder = `[${this.cutFloat(latlng.lat)} : ${this.cutFloat(latlng.lng)}]`;
        if (withClearAddress) {
            this.page.ctrls.iFromAddress.value = "";
            this._route = null;
        }
    }
    setEndPoint(latlng, withClearAddress = false) {
        if (!latlng)
            return;
        this._mapEndMarker.setLatLng(latlng);
        this._pointEnd = latlng;
        this.page.ctrls.iToAddress.el.placeholder = `[${this.cutFloat(latlng.lat)}:${this.cutFloat(latlng.lng)}]`;
        if (withClearAddress) {
            this.page.ctrls.iToAddress.value = "";
            this._route = null;
        }
    }
    _trySelectUser() {
        return __awaiter(this, void 0, void 0, function* () {
            const user = yield StateProfiles_1.StateProfiles.SelectUser();
            if (!user)
                return;
            this._setCustomer(user);
            yield gs_1.StateGS.RunInstance(this);
        });
    }
    _setCustomer(user) {
        this._customer = user;
        const item = new com.ListItem();
        item.ctrls.lType.text = "Customer";
        item.ctrls.lId.text = `#${user.id}`;
        let data = [gs.text.clearHtmlToText(`${user.name} ${user.surname}`)];
        item.ctrls.pData.html = data.join("<br>");
        this.page.ctrls.listUsers.html = "";
        this.page.ctrls.listUsers.append(item);
    }
    cutFloat(f) {
        return Math.round(f * 10000000) / 10000000;
    }
}
exports.StateCustomerNewOrder = StateCustomerNewOrder;
StateCustomerNewOrder.StateName = "customerNewOrder";
//# sourceMappingURL=StateCustomerNewOrder.js.map